export const sanitizeStringLength = (str: string, maxLength: number) =>
  str.slice(0, Math.min(str.length, maxLength));
